import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from '@/components/ui/context-menu'
import { cn } from '@/utils'

interface OptionsContextMenuProps {
  optionsGroups: {
    options: { label: string; action: () => void; testId?: string }[]
    groupTestId?: string
    title?: string
  }[]
  isDisabled?: boolean
  children: React.ReactNode
  onAuxClick?: (event: React.MouseEvent) => void
  onOpenChange?: (open: boolean) => void
  asChild?: boolean
  isReadonly?: boolean
}

export const OptionsContextMenu: React.FC<OptionsContextMenuProps> = ({
  optionsGroups,
  isDisabled,
  children,
  onAuxClick,
  onOpenChange,
  asChild,
  isReadonly,
}) => {
  return !isReadonly ? (
    <ContextMenu onOpenChange={onOpenChange}>
      <ContextMenuTrigger
        asChild={asChild}
        onAuxClick={onAuxClick}
        onContextMenu={onAuxClick}
      >
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent className="bg-white rounded shadow border p-1 w-48">
        {optionsGroups.map(({ title, options, groupTestId }, index) =>
          options.length ? (
            <div
              key={index}
              className="mb-2 border-b last:border-0 last:mb-0"
              data-testid={groupTestId}
            >
              {title && (
                <div className="px-3 py-1 text-xs font-semibold text-gray-600">
                  {title}
                </div>
              )}
              {options.map(({ label, action, testId }) => (
                <ContextMenuItem
                  key={label}
                  onSelect={isDisabled ? () => {} : action}
                  data-testid={testId}
                  className={cn(
                    'px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 rounded',
                    {
                      'text-gray-400': isDisabled,
                    },
                  )}
                >
                  {label}
                </ContextMenuItem>
              ))}
            </div>
          ) : null,
        )}
      </ContextMenuContent>
    </ContextMenu>
  ) : (
    <>{children}</>
  )
}
